/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\hostacquisition.genclient.json
 */

"use strict";

import Contracts = require("VSS/HostAcquisition/Contracts");
import VSS_Organization_Contracts = require("VSS/Organization/Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");

export class CommonMethods4To7_2 extends VSS_WebApi.VssHttpClient {

    public static serviceInstanceId = "00000041-0000-8888-8000-000000000000";
    protected nameAvailabilityApiVersion: string;
    protected regionsApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Preview API]
     *
     * @return IPromise<Contracts.Region[]>
     */
    public getRegions(): IPromise<Contracts.Region[]> {

        return this._beginRequest<Contracts.Region[]>({
            httpMethod: "GET",
            area: "HostAcquisition",
            locationId: "776ef918-0dad-4eb1-a614-04988ca3a072",
            resource: "Regions",
            routeTemplate: "_apis/{area}/{resource}",
            responseIsCollection: true,
            apiVersion: this.regionsApiVersion
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} name
     * @return IPromise<Contracts.NameAvailability>
     */
    public getNameAvailability(
        name: string
        ): IPromise<Contracts.NameAvailability> {

        return this._beginRequest<Contracts.NameAvailability>({
            httpMethod: "GET",
            area: "HostAcquisition",
            locationId: "01a4cda4-66d1-4f35-918a-212111edc9a4",
            resource: "NameAvailability",
            routeTemplate: "_apis/{area}/{resource}/{name}",
            routeValues: {
                name: name
            },
            apiVersion: this.nameAvailabilityApiVersion
        });
    }
}

export class CommonMethods7_1To7_2 extends CommonMethods4To7_2 {
    protected collectionsApiVersion: string;
    protected geographiesApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Preview API]
     *
     * @return IPromise<Contracts.Geography[]>
     */
    public getGeographies(): IPromise<Contracts.Geography[]> {

        return this._beginRequest<Contracts.Geography[]>({
            httpMethod: "GET",
            area: "HostAcquisition",
            locationId: "81f025e6-8678-42bc-aa6f-2a3cc2df3b75",
            resource: "Geographies",
            routeTemplate: "_apis/{area}/{resource}",
            responseIsCollection: true,
            apiVersion: this.geographiesApiVersion
        });
    }

    /**
     * [Preview API] Creates a new collection of the given name in the given region
     *
     * @param {{ [key: string] : string; }} properties
     * @param {string} collectionName
     * @param {string} preferredRegion
     * @param {string} preferredGeography
     * @param {string} ownerDescriptor
     * @return IPromise<VSS_Organization_Contracts.Collection>
     */
    public createCollection(
        properties: { [key: string] : string; },
        collectionName: string,
        preferredRegion: string,
        preferredGeography?: string,
        ownerDescriptor?: string
        ): IPromise<VSS_Organization_Contracts.Collection> {

        const queryValues: any = {
            collectionName: collectionName,
            preferredRegion: preferredRegion,
            preferredGeography: preferredGeography,
            ownerDescriptor: ownerDescriptor
        };

        return this._beginRequest<VSS_Organization_Contracts.Collection>({
            httpMethod: "POST",
            area: "HostAcquisition",
            locationId: "2bbead06-ca34-4dd7-9fe2-148735723a0a",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: VSS_Organization_Contracts.TypeInfo.Collection,
            queryParams: queryValues,
            apiVersion: this.collectionsApiVersion,
            data: properties
        });
    }
}

/**
 * @exemptedapi
 */
export class HostAcquisitionHttpClient7_2 extends CommonMethods7_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.geographiesApiVersion =
        this.nameAvailabilityApiVersion =
        this.regionsApiVersion = "7.2-preview.1";
        this.collectionsApiVersion = "7.2-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class HostAcquisitionHttpClient7_1 extends CommonMethods7_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.geographiesApiVersion =
        this.nameAvailabilityApiVersion =
        this.regionsApiVersion = "7.1-preview.1";
        this.collectionsApiVersion = "7.1-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class HostAcquisitionHttpClient7 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.nameAvailabilityApiVersion =
        this.regionsApiVersion = "7.0-preview.1";
    }

    /**
     * [Preview API] Creates a new collection of the given name in the given region
     *
     * @param {{ [key: string] : string; }} properties
     * @param {string} collectionName
     * @param {string} preferredRegion
     * @param {string} ownerDescriptor
     * @return IPromise<VSS_Organization_Contracts.Collection>
     */
    public createCollection(
        properties: { [key: string] : string; },
        collectionName: string,
        preferredRegion: string,
        ownerDescriptor?: string
        ): IPromise<VSS_Organization_Contracts.Collection> {

        const queryValues: any = {
            collectionName: collectionName,
            preferredRegion: preferredRegion,
            ownerDescriptor: ownerDescriptor
        };

        return this._beginRequest<VSS_Organization_Contracts.Collection>({
            httpMethod: "POST",
            area: "HostAcquisition",
            locationId: "2bbead06-ca34-4dd7-9fe2-148735723a0a",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: VSS_Organization_Contracts.TypeInfo.Collection,
            queryParams: queryValues,
            apiVersion: "7.0-preview.3",
            data: properties
        });
    }
}

/**
 * @exemptedapi
 */
export class HostAcquisitionHttpClient6_1 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.nameAvailabilityApiVersion =
        this.regionsApiVersion = "6.1-preview.1";
    }

    /**
     * [Preview API] Creates a new collection of the given name in the given region
     *
     * @param {{ [key: string] : string; }} properties
     * @param {string} collectionName
     * @param {string} preferredRegion
     * @param {string} ownerDescriptor
     * @return IPromise<VSS_Organization_Contracts.Collection>
     */
    public createCollection(
        properties: { [key: string] : string; },
        collectionName: string,
        preferredRegion: string,
        ownerDescriptor?: string
        ): IPromise<VSS_Organization_Contracts.Collection> {

        const queryValues: any = {
            collectionName: collectionName,
            preferredRegion: preferredRegion,
            ownerDescriptor: ownerDescriptor
        };

        return this._beginRequest<VSS_Organization_Contracts.Collection>({
            httpMethod: "POST",
            area: "HostAcquisition",
            locationId: "2bbead06-ca34-4dd7-9fe2-148735723a0a",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: VSS_Organization_Contracts.TypeInfo.Collection,
            queryParams: queryValues,
            apiVersion: "6.1-preview.3",
            data: properties
        });
    }
}

/**
 * @exemptedapi
 */
export class HostAcquisitionHttpClient6 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.nameAvailabilityApiVersion =
        this.regionsApiVersion = "6.0-preview.1";
    }

    /**
     * [Preview API] Creates a new collection of the given name in the given region
     *
     * @param {{ [key: string] : string; }} properties
     * @param {string} collectionName
     * @param {string} preferredRegion
     * @param {string} ownerDescriptor
     * @return IPromise<VSS_Organization_Contracts.Collection>
     */
    public createCollection(
        properties: { [key: string] : string; },
        collectionName: string,
        preferredRegion: string,
        ownerDescriptor?: string
        ): IPromise<VSS_Organization_Contracts.Collection> {

        const queryValues: any = {
            collectionName: collectionName,
            preferredRegion: preferredRegion,
            ownerDescriptor: ownerDescriptor
        };

        return this._beginRequest<VSS_Organization_Contracts.Collection>({
            httpMethod: "POST",
            area: "HostAcquisition",
            locationId: "2bbead06-ca34-4dd7-9fe2-148735723a0a",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: VSS_Organization_Contracts.TypeInfo.Collection,
            queryParams: queryValues,
            apiVersion: "6.0-preview.3",
            data: properties
        });
    }
}

/**
 * @exemptedapi
 */
export class HostAcquisitionHttpClient5_2 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.nameAvailabilityApiVersion =
        this.regionsApiVersion = "5.2-preview.1";
    }

    /**
     * [Preview API] Creates a new collection of the given name in the given region
     *
     * @param {{ [key: string] : string; }} properties
     * @param {string} collectionName
     * @param {string} preferredRegion
     * @param {string} ownerDescriptor
     * @return IPromise<VSS_Organization_Contracts.Collection>
     */
    public createCollection(
        properties: { [key: string] : string; },
        collectionName: string,
        preferredRegion: string,
        ownerDescriptor?: string
        ): IPromise<VSS_Organization_Contracts.Collection> {

        const queryValues: any = {
            collectionName: collectionName,
            preferredRegion: preferredRegion,
            ownerDescriptor: ownerDescriptor
        };

        return this._beginRequest<VSS_Organization_Contracts.Collection>({
            httpMethod: "POST",
            area: "HostAcquisition",
            locationId: "2bbead06-ca34-4dd7-9fe2-148735723a0a",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: VSS_Organization_Contracts.TypeInfo.Collection,
            queryParams: queryValues,
            apiVersion: "5.2-preview.3",
            data: properties
        });
    }
}

/**
 * @exemptedapi
 */
export class HostAcquisitionHttpClient5_1 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.nameAvailabilityApiVersion =
        this.regionsApiVersion = "5.1-preview.1";
    }

    /**
     * [Preview API] Creates a new collection of the given name in the given region
     *
     * @param {{ [key: string] : string; }} properties
     * @param {string} collectionName
     * @param {string} preferredRegion
     * @param {string} ownerDescriptor
     * @return IPromise<VSS_Organization_Contracts.Collection>
     */
    public createCollection(
        properties: { [key: string] : string; },
        collectionName: string,
        preferredRegion: string,
        ownerDescriptor?: string
        ): IPromise<VSS_Organization_Contracts.Collection> {

        const queryValues: any = {
            collectionName: collectionName,
            preferredRegion: preferredRegion,
            ownerDescriptor: ownerDescriptor
        };

        return this._beginRequest<VSS_Organization_Contracts.Collection>({
            httpMethod: "POST",
            area: "HostAcquisition",
            locationId: "2bbead06-ca34-4dd7-9fe2-148735723a0a",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: VSS_Organization_Contracts.TypeInfo.Collection,
            queryParams: queryValues,
            apiVersion: "5.1-preview.3",
            data: properties
        });
    }
}

/**
 * @exemptedapi
 */
export class HostAcquisitionHttpClient5 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.nameAvailabilityApiVersion =
        this.regionsApiVersion = "5.0-preview.1";
    }

    /**
     * [Preview API] Creates a new collection of the given name in the given region
     *
     * @param {{ [key: string] : string; }} properties
     * @param {string} collectionName
     * @param {string} preferredRegion
     * @param {string} ownerDescriptor
     * @return IPromise<VSS_Organization_Contracts.Collection>
     */
    public createCollection(
        properties: { [key: string] : string; },
        collectionName: string,
        preferredRegion: string,
        ownerDescriptor?: string
        ): IPromise<VSS_Organization_Contracts.Collection> {

        const queryValues: any = {
            collectionName: collectionName,
            preferredRegion: preferredRegion,
            ownerDescriptor: ownerDescriptor
        };

        return this._beginRequest<VSS_Organization_Contracts.Collection>({
            httpMethod: "POST",
            area: "HostAcquisition",
            locationId: "2bbead06-ca34-4dd7-9fe2-148735723a0a",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: VSS_Organization_Contracts.TypeInfo.Collection,
            queryParams: queryValues,
            apiVersion: "5.0-preview.2",
            data: properties
        });
    }
}

/**
 * @exemptedapi
 */
export class HostAcquisitionHttpClient4_1 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.nameAvailabilityApiVersion =
        this.regionsApiVersion = "4.1-preview.1";
    }

    /**
     * [Preview API] Creates a new collection of the given name in the given region
     *
     * @param {{ [key: string] : string; }} properties
     * @param {string} collectionName
     * @param {string} preferredRegion
     * @param {string} ownerDescriptor
     * @return IPromise<VSS_Organization_Contracts.Collection>
     */
    public createCollection(
        properties: { [key: string] : string; },
        collectionName: string,
        preferredRegion: string,
        ownerDescriptor?: string
        ): IPromise<VSS_Organization_Contracts.Collection> {

        const queryValues: any = {
            collectionName: collectionName,
            preferredRegion: preferredRegion,
            ownerDescriptor: ownerDescriptor
        };

        return this._beginRequest<VSS_Organization_Contracts.Collection>({
            httpMethod: "POST",
            area: "HostAcquisition",
            locationId: "2bbead06-ca34-4dd7-9fe2-148735723a0a",
            resource: "Collections",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: VSS_Organization_Contracts.TypeInfo.Collection,
            queryParams: queryValues,
            apiVersion: "4.1-preview.2",
            data: properties
        });
    }
}

/**
 * @exemptedapi
 */
export class HostAcquisitionHttpClient4 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.nameAvailabilityApiVersion =
        this.regionsApiVersion = "4.0-preview.1";
    }
}

export class HostAcquisitionHttpClient extends HostAcquisitionHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": HostAcquisitionHttpClient7_2,
    "7.1": HostAcquisitionHttpClient7_1,
    "7.0": HostAcquisitionHttpClient7,
    "6.1": HostAcquisitionHttpClient6_1,
    "6.0": HostAcquisitionHttpClient6,
    "5.2": HostAcquisitionHttpClient5_2,
    "5.1": HostAcquisitionHttpClient5_1,
    "5.0": HostAcquisitionHttpClient5,
    "4.1": HostAcquisitionHttpClient4_1,
    "4.0": HostAcquisitionHttpClient4
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return HostAcquisitionHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): HostAcquisitionHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<HostAcquisitionHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<HostAcquisitionHttpClient7_1>(HostAcquisitionHttpClient7_1, undefined, undefined, undefined, options);
    }
}
